import { createContext } from 'react'
import theme from '../theme'

export default createContext(theme)
